const transactions = {
  transactions: `Transacciones`,
  transaction: `Transacción`,
  no_transactions_found: `No se encontraron transacciones`,
  sent_money_to: `Envió dinero a`,
  received_money_from: `Recibió dinero de`,
  transactedAt: `Transaccionado en`,
  not_available_testing_mode: "No disponible en modo de prueba",
  gateway_not_connected: "Pasarela de pago no conectada",
  transacted_by: `Realizado por`,
  transacted_on: `Realizado el`,
  status: `Estado`,
  received: `Recibido`,
  sent: `Enviado`,
  BankTransfer: "Transferencia bancaria",
  processed_by_and_date: "Procesado por y fecha",
  transaction_type: `Tipo de transacción`,
  debit: `Débito`,
  credit: `Crédito`,
  delete_transaction_warning: `La transacción eliminada no se puede recuperar`,
  delete_transaction: `Está seguro de que desea eliminar esta transacción`,
  deactive_not_allowed: `Desactivación no permitida`,
  transaction_deleted_successfully: `Transacción eliminada exitosamente`,
  actions: `Acciones`,
};
export default transactions;
